import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  bannerImgOne,
  bannerImgTwo,
  bannerImgThree,
} from "../../assets/images";
import Image from "../designLayouts/Image";

const Banner = () => {
  const bannerStyle = {
    
    width: "100%",
    overflow: "hidden",
  };
  
  const imageStyle = {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  };
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,

  };

  return (
    <div className="maxWidth w-full bg-white">
      <Slider {...settings}>
      <Link to="/offer">
    <div style={bannerStyle}>
      <Image imgSrc={bannerImgOne} style={imageStyle} />
    </div>
  </Link>
  <Link to="/offer">
    <div style={bannerStyle}>
      <Image imgSrc={bannerImgTwo} style={imageStyle} />
    </div>
  </Link>
  <Link to="/offer">
    <div style={bannerStyle}>
      <Image imgSrc={bannerImgThree} style={imageStyle} />
    </div>
  </Link>
      </Slider>
    </div>
  );
};

export default Banner;
